import type { InjectionKey } from 'vue'

export interface ITabState {
  activeTab: number
  tabs: string[]
  counts: any
}

export const stateKey = Symbol('tabs:state') as InjectionKey<ITabState>
export const addTabKey = Symbol('tabs:addTab') as InjectionKey<(tab: string) => void>
export const updateTabKey = Symbol('tabs:updateTab') as InjectionKey<(oldTab: string, newTab: string) => void>
export const removeTabKey = Symbol('tabs:removeTab') as InjectionKey<(tab: string) => void>
export const updateTabCountKey = Symbol('tabs:updateCountTab') as InjectionKey<(tab: string, count?: number) => void>
